import React, { Fragment } from "react"
const LayoutTitleParagraphs = ({ children, styles }) => {
  if (styles && styles.includes("multiple-columns")) {
    return <Fragment>{children}</Fragment>
  }
  return <div className="col-lg-8">{children}</div>
}

export default LayoutTitleParagraphs
